import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="w-full bg-black-main-dark">
      <section
        className="w-full min-h-screen flex flex-col justify-center items-center text-center px-6 bg-black-main-dark"
        id="home"
      >
        <div className="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center pt-24">
          {/* Heading */}
          <h1 className="mb-2 text-4xl sm:text-5xl md:text-7xl xl:text-8xl font-extrabold leading-tight tracking-tight text-white">
            Build Wealth with
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-primary1 to-secondary">
              Discipline.
            </span>
          </h1>

          <h1 className="mb-8 text-4xl sm:text-5xl md:text-7xl xl:text-8xl font-extrabold leading-tight tracking-tight text-white">
            Not{" "}
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-primary1 to-secondary">
              Guesswork.
            </span>
          </h1>

          {/* Subtext */}
          <p className="mb-12 text-base sm:text-xl text-gray-200 max-w-3xl mx-auto">
            Helping salaried professionals build long-term wealth through mutual
            funds & structured investing.
          </p>

          {/* CTA */}
          <div className="mb-4">
            <Link
              to="/free-portfolio-check"
              className="inline-flex items-center justify-center px-6 py-3 text-lg text-white bg-primary1 rounded-2xl hover:opacity-90 transition"
            >
              Free Portfolio Check
              <svg
                className="w-4 h-4 ml-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
